module.exports = "../../../../platform/assets/pageMainIcon/industry_jichudanganlei7.svg";